export default "__VITE_ASSET__2ede94a7__"